import {apiClient} from '@/services/base/BaseService';
import {ISupplier} from '@/models/ISupplier';

export async function getListSuppliers(organizationId: number, shopId: number) {
    const res = await apiClient.get(`organizations/${organizationId}/shops/${shopId}/suppliers`);

    return res.data.data as ISupplier[];
}

export async function createSupplier(organizationId: number, shopId: number, name: string, email: string, productIds: number[]) {
    return await apiClient.post(`organizations/${organizationId}/shops/${shopId}/suppliers`, {
        name,
        email,
        product_ids: productIds,
    });
}

// tslint:disable-next-line:max-line-length
export async function updateSupplier(organizationId: number, shopId: number, supplierId: number, name: string, email: string, productIds: number[]) {
    return await apiClient.post(`organizations/${organizationId}/shops/${shopId}/suppliers/${supplierId}`, {
        name,
        email,
        product_ids: productIds,
    });
}

export async function getSupplierById(organizationId: number, shopId: number, supplierId: number) {
    const res = await apiClient.get(`organizations/${organizationId}/shops/${shopId}/suppliers/${supplierId}`);

    return res.data.data;
}

export async function deleteSupplier(organizationId: number, shopId: number, supplierId: number) {
    const res = await apiClient.delete(`organizations/${organizationId}/shops/${shopId}/suppliers/${supplierId}`);

    return res.status === 200;
}
